import { TranslatePipe } from '@ngx-translate/core';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'i18nMessage',
  pure: false,
  standalone: false,
})
export class I18nMessagePipe extends TranslatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return super.transform(`message:${value}`, args);
  }
}
